import React from 'react';
import { Order } from '@interfaces/models/myOrder';
import { Product } from '@interfaces/models/orderSaleProduct';
import { TimelineConfirmDeliveryAction } from '@interfaces/models/timeline';
import useAnalyticEvents from '@hooks/analytics/use-analytic-events';
import { useTranslation } from 'next-i18next';
import ConfirmDeliveryCommon from './confirm-delivery-common';

const ConfirmDeliveryView: React.FC<{
  closePopin: () => void;
  product: Product;
  order: Order | null;
  confirmDeliveryDetails: TimelineConfirmDeliveryAction;
}> = ({ closePopin, confirmDeliveryDetails, product, order }) => {
  const { t } = useTranslation('orders-sales');
  const { sendAnalyticEvent } = useAnalyticEvents('orders_sales_timeline');
  const analyticData = { label: 'seller', product_id: product.productId };

  const handleCancel = () => {
    sendAnalyticEvent('timeline_return_card_popin_go_back', analyticData);
  };

  const handleConfirm = () => {
    sendAnalyticEvent('timeline_return_card_popin_confirm', analyticData);
  };

  return (
    <ConfirmDeliveryCommon
      closePopin={closePopin}
      confirmDeliveryDetails={confirmDeliveryDetails}
      product={product}
      order={order}
      title={t('MY_ACCOUNT.ORDERS_SALES.POPUP.SELLER_CONFIRM_DELIVERY.TITLE')}
      body={t('MY_ACCOUNT.ORDERS_SALES.POPUP.SELLER_CONFIRM_DELIVERY.BODY')}
      cancelButtonText={t('MY_ACCOUNT.ORDERS_SALES.GO_BACK')}
      confirmButtonText={t('MY_ACCOUNT.ORDERS_SALES.CONFIRM')}
      onCancel={handleCancel}
      onConfirm={handleConfirm}
    />
  );
};

export default ConfirmDeliveryView;
